var Turtlemirror = require('./lib');
export default Turtlemirror;
